module.exports = __webpack_public_path__ + "static/logoV2-1f0c306fb1183180db470c7500853b6b.png";